
import { mapState, mapActions } from "vuex";
export default {
  props: {
    combo: {},
    highlightText: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isComboActive: false,
      loading: false
    };
  },
  mounted() {
    this.syncActivestate();
  },
  watch: {
    combo: {
      handler(val) {
        this.syncActivestate();
      },
      deep: true
    }
  },
  computed: {
    getName() {
      if (this.highlightText) {
        return this.getHighlightedText(this.combo.name, this.highlightText);
      } else {
        return this.combo.name;
      }
    }
  },
  methods: {
    ...mapActions("menu", ["changeComboItemStatus", "getCombosList"]),
    syncActivestate() {
      this.isComboActive = this.combo.is_active;
    },
    async handleStatusChange() {
      this.loading = true;
      try {
        await this.changeComboItemStatus({
          itemId: this.combo.id,
          status: this.isComboActive
        });
        await this.getCombosList(true);
      } catch (error) {
        this.isComboActive = !this.isComboActive;
        this.$nuxt.$emit("show-error-toast", error);
      }
      this.loading = false;
    }
  }
};
